module.exports = __webpack_public_path__ + "static/img/wczd-details.9589f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wczd-details.png
// module id = cH5Y
// module chunks = 0